module.exports = __webpack_public_path__ + "media/images/webpage/hotels/7167/plan2-2-5d3ec71da6a4dd30f926abe5ae276742.webp";